import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Table } from "../../../features/Table";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import { type S3PdfPageSelection, columns } from "./columns";
import {
  type FilterS3PdfPageSelectionSchema,
  S3PdfPageSelectionFilter,
} from "./filter";

export const S3PdfPageSelectionTable = () => {
  const [searchParams] = useSearchParams();
  const { t } = useTranslation("tables");
  const client = searchParams.get("client") || Clients.S3;

  return (
    <Table<S3PdfPageSelection, FilterS3PdfPageSelectionSchema>
      label={t("s3_pdf_page_selection.title", { defaultValue: "PDF page selection" })}
      client={client}
      table_name={Tables.S3_PDF_PAGE_SELECTION}
      columns={columns}
      filter={<S3PdfPageSelectionFilter />}
      disable_translations_request={true}
      columnVisibilityInit={{
        tableau_view: false,
        tableau_workbook_id: false,
        created_at: false,
      }}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${Tables.S3_PDF_PAGE_SELECTION}/new`,
        },
      ]}
    />
  );
};
